import { sendPost } from '../http.js'
import uploadUrl from '@/utils/uploads.js'
const commons = (url, params, fn) => {
  return sendPost(url, params)
    .then((res) => {
      fn(res)
      //console.log('成功')
    }).catch((err) => {
		throw Error(err)
      fn(err)
      //console.log('失败')
  })
}
const api = {
	'getUploadToken': '/user/upload/getalltoken',
	'uploadFile': uploadUrl,
	'materialAdd': '/material/addv2',
	'materialIndex': '/material/index',
	'materialRemove': '/material/remove',
	'materialEditName': '/material/edit/name',
	'uploadImgToWxAPI': '/wechat/video/uploadImg' // 图片url上传到自己后端，然后自己后端上传到微信的接口
}

export default {
	getUploadToken(params) {
	    return sendPost(api.getUploadToken, params)
	},
	uploadFile(params) {
		return sendPost(api.uploadFile, params)
	},
	materialAdd(params) {
		return sendPost(api.materialAdd, params)
	},
	materialIndex(params) {
		return sendPost(api.materialIndex, params)
	},
	materialRemove(params) {
		return sendPost(api.materialRemove, params)
	},
	materialEditName(params) {
		return sendPost(api.materialEditName, params)
	},
	uploadImgToWxAPI(params) {
		return sendPost(api.uploadImgToWxAPI, params)
	}
}